
import { EnumCompagnieActions } from './CompagnieActions';
//import update from 'react-addons-update';
import update from 'immutability-helper';

const EnumActions = EnumCompagnieActions;

const initialState = {

    listaCompagnie: [],
    compagnia: {},
    puntiVendita: [],
    puntoVendita: {}

}

const compagnie = (state, action) => {
    if (typeof state === 'undefined') {
        return initialState
    }

    let moduleName = "[CompagnieReducer.js]"
    switch (action.type) {

        case EnumCompagnieActions.INITIALIZED:
            return initialState
        case EnumCompagnieActions.LIST_COMPAGNIE:
            return Object.assign({}, state, { listaCompagnie: action.dati })

        case EnumCompagnieActions.COMPAGNIA_DETAILS:
            return Object.assign({}, state, { compagnia: action.dati })

        case EnumCompagnieActions.COMPAGNIA_HANDLE_CHANGE:
            return update(state, {
                compagnia: { $merge: action.dato }
            });

        case EnumCompagnieActions.PUNTO_VENDITA_HANDLE_CHANGE:
            return update(state, {
                puntoVendita: { $merge: action.dato }
            });

        case EnumCompagnieActions.COMPAGNIA_UPDATE:
            return update(state, action.compagnia
            );
        case EnumCompagnieActions.PUNTO_VENDITA_INITIALIZED:
            return Object.assign({}, state, {puntoVendita:{} 
            });

        default:
            return state;
    }
}

export default compagnie;